import type { IBaseControlSetting, EControlType } from '~/presentation/reports/common/type';
import type { IconSource, InlineStackProps } from '@shopify/polaris';

import { SelectBaseContent } from './SelectBaseContent';
import { useToggle } from '~/hooks/useToggle';

export interface IControlSelectBase extends IBaseControlSetting {
  type: EControlType.SELECT_BASE;
  icon?: IconSource;
  children?: React.ReactNode;
  textVariant?: 'bodyMd' | 'bodySm' | 'bodyXs' | 'bodyLg';
  onClick?: () => void;
  labelAlign?: InlineStackProps['align'];
  onDelete?: () => void;
}

export const SelectBase: React.FC<IControlSelectBase> = (props) => {
  const { draggable, onClick } = props;
  const { provided } = draggable || {};
  const { setFalse, setTrue, value: isHovered } = useToggle(false);

  return (
    <div
      ref={provided?.innerRef}
      {...provided?.draggableProps}
      onMouseEnter={setTrue}
      onMouseLeave={setFalse}
      onClick={onClick}
    >
      <SelectBaseContent {...props} isHovered={isHovered} />
    </div>
  );
};
